// src/api/adminClient.js


// const BASE = process.env.REACT_APP_API_URL ?? `http://${window.location.hostname}:8000`;

// 배포용
const BASE =
    process.env.REACT_APP_API_URL ?? `${window.location.origin}/api`;

function adminAuthHeader() {
    const t = localStorage.getItem("adm_token");
    return t ? { Authorization: `Bearer ${t}` } : {};
}

// 401/403 자동 처리용 콜백
let _onAuthError = null;
export function setAdminAuthErrorHandler(fn) {
    _onAuthError = fn;
}

export default async function adminRequest(
    path,
    { method = "GET", headers = {}, body, credentials } = {}
) {
    const isJson = body && typeof body === "object" && !(body instanceof FormData);

    const res = await fetch(`${BASE}${path}`, {
        method,
        headers: {
            ...(isJson ? { "Content-Type": "application/json" } : {}),
            ...headers,
            ...adminAuthHeader(),
        },
        credentials, // 필요시 "include"
        body: isJson ? JSON.stringify(body) : body,
    });

    const ct = res.headers.get("content-type") || "";

    let data = null;
    if (res.status !== 204 && res.status !== 205) {
        data = ct.includes("application/json") ? await res.json() : await res.text();
    }

    if (!res.ok) {
        if ((res.status === 401 || res.status === 403) && _onAuthError) {
            try { _onAuthError(res, data); } catch { }
        }
        const msg =
            (data && (data.detail || data.message)) ||
            `${res.status} ${res.statusText}` ||
            "요청 실패";
        const err = new Error(msg);
        err.status = res.status;
        err.data = data;
        throw err;
    }

    return data; // 204면 null 반환
}

